import { useI18n } from '../i18n';
import { TermsBody } from '../components/LegalContent';
import { LangSwitcher } from '../components/LangSwitcher';

/**
 * Standalone terms page at /:locale/terms (+ unprefixed /terms). Same
 * rationale as Privacy.tsx — store listings link to a stable URL.
 */
export function Terms() {
  const { t, localePath } = useI18n();
  return (
    <main class="legal-page">
      <div class="legal-page__shell">
        <div class="legal-page__top">
          <a class="legal-page__back" href={localePath('/')}>← BeerCup</a>
          <LangSwitcher theme="light" />
        </div>
        <h1 class="legal-page__title">{t('legal.terms_title')}</h1>
        <div class="legal-page__body">
          <TermsBody />
        </div>
        <nav class="legal-page__nav" aria-label="legal pages">
          <a href={localePath('/privacy')}>{t('legal.privacy_title')}</a>
          <span>·</span>
          <a href={localePath('/support')}>{t('support.title')}</a>
          <span>·</span>
          <a href={localePath('/account/delete')}>{t('account.delete.title')}</a>
        </nav>
      </div>
    </main>
  );
}
